<template>
  <div class="loan">
    <!-- Loading spinner -->
    <div style="position: fixed; top: 50%; left: 50%; z-index: 999;">
      <!-- Add spinner here if needed -->
    </div>

    <!-- Error Notification -->
    <div class="mb-3" v-if="processingError">
      <va-notification color="danger" closeable>
        An error occurred! Please try again later.
      </va-notification>
    </div>

    <div class="row">
      <div class="flex s12 md9">
        <!-- Clean Vuestic Card (no titleOnImage slot issue) -->
        <va-card>
          <div class="card-header d-flex justify-between align-center mb-3">
            <h4 class="text-primary font-semibold mb-0">
              {{ $t('crmListCRMs') }}
            </h4>
            <va-button icon="fa fa-close" color="danger" @click="$router.go(-1)">
              Cancel
            </va-button>
          </div>

          <!-- Search Input -->
          <va-input
            class="ma-0 mb-4"
            v-model="term"
            :placeholder="$t('Search by description or status')"
            clearable
          >
            <template #prepend>
              <va-icon name="fa fa-search" />
            </template>
          </va-input>

          <!-- Data Table -->
          <va-data-table
            :fields="mode ? detailedFields : fields"
            :data="filteredData"
            :loading="loading"
            hoverable
          >
            <template #icon>
              <va-icon name="fa fa-list" color="secondary" />
            </template>

            <template #code="{ rowData }">
              {{ rowData.code }}
            </template>

            <template #description="{ rowData }">
              {{ rowData.description }}
            </template>

            <template #type="{ rowData }">
              {{ rowData.type }}
            </template>

            <template #status="{ rowData }">
              {{ rowData.status }}
            </template>
          </va-data-table>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script src="https://unpkg.com/vue@2.5.13/dist/vue.js"></script>
<script>
import axios from 'axios'
import * as spinners from 'epic-spinners'
import debounce from 'lodash/debounce'

export default {
  components: {
    ...spinners      
  },
  name: 'loan',
  data () {
    return {
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      accdetails: JSON.parse(localStorage.getItem('UserMianFosa')),
      token: JSON.parse(localStorage.getItem('Token')),   
      loan_no : this.$route.params.loan_no,
      loading: false,
      term: null,
      loadSelect:false,
   
      details:{},
  
      config: {
        size: 80,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      sliderDuration: {
        min: 1000,
        max: 2000,
      }     
    }
  },
  computed: {
    speed () {
      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
    },

fields () {
      return [{
        name: '__slot:icon',
        width: '30px',
        dataClass: 'text-center',
      }, {
        name: '__slot:code',
        title: this.$t('CRM Number'),
        width: '30%',
        sortField: 'amount',
      }, 
      {
        name: '__slot:descripton',
        title: this.$t('Description'),
        width: '50%',
        sortField: 'amount',
      },
      {
        name: '__slot:type',
        title: this.$t('Contacted for'),
        width: '20%',
        sortField: 'amount',
      },
      {
        name: '__slot:status',
        title: this.$t('Status'),
        width: '20%',
        sortField: 'amount',
      },
   
]
    },
    filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.details
      }
      console.log(this.term);
      return this.details.filter(item => {
        return item.descripton.toLowerCase().startsWith(this.term.toLowerCase()) || item.status.toLowerCase().startsWith(this.term.toLowerCase())
       
      })
    },
    formReady () {

     },      
  },
  methods : {
    GetProduct(id) {      
      return this.loans.filter(item => item.loanType.toLowerCase() === this.id.toLowerCase());      
    },
    
 
    onsubmit () {

    },

    GetCRMListing () {
      this.loadSelect = true
      this.loading = true
      const self = this
      const form = {
  user:this.userData.user_id,
  phonenumber: this.userData.mobile_number
      }
      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}ListCRMMember`, form, config)
      .then(function (res) {

          self.loadSelect = false
          self.loading = false
          res = res.data
          self.details =  res.slice().reverse()

      })
      .catch(function (error) {
          console.log(error)
      })
    },
    search: debounce(function (term) {
      console.log(term)
      this.term = term
    }, 400),

  },
  created () { 
    this.GetCRMListing();
   
 
  }
}
</script>